module.exports = __webpack_public_path__ + "static/img/djrm-2.347b82de.jpg";